<template>
	<span :class="`alert alert-${flashKey}`" role="alert" v-show="flash">
		<div class="row">
			<div class="col-1">
				<span class="flash-icon">
					<template v-if="flashKey == 'success'">
						<svg-rndr svg="check-circle-dark-green-chunky.svg" />
					</template>
					<template v-else-if="flashKey == 'info'">
						<svg-rndr svg="warning.svg" />
					</template>
					<template v-else-if="flashKey == 'warning'">
						<svg-rndr svg="warning.svg" />
					</template>
					<template v-else-if="flashKey == 'error'">
						<svg-rndr svg="warning.svg" />
					</template>
				</span>
			</div>
			<div class="col">
				<span v-html="flash"></span>
			</div>
		</div>
	</span>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'FlashMessage',
    computed: {
        ...mapState('Flash', ['flash', 'flashKey'])
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/FlashMessage.vue